import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Menu, Button, Row, Col, Layout, Affix, Dropdown, Space } from 'antd';
import { GlobalOutlined, UserOutlined } from '@ant-design/icons';
import { setIsUiHidden } from 'store/entities/ui';
import useRedirect from 'hooks/navigation/useRedirect';
import { ReactComponent as NewCreditLogo } from 'assets/img/icons/newCreditLogo.svg';
import { languages } from '../../../i18n';
import HeaderSearch from './HeaderSearcb';
import usePathSegments from '../../../hooks/dom/usePathSegments';
import DisabledProfModal from '../../CompanySearchResult/components/DisabledProfModal';

const { Content } = Layout;

const UnauthenticatedWrapper = ({ children }) => {
  const { publicProfView } = useSelector(state => state.ui);
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const redirect = useRedirect();
  const pathSegments = usePathSegments();
  const activeSearch = pathSegments[pathSegments.length - 1] === 'result' || publicProfView;
  const [activeDisabledCompany, setActiveDisabledCompany] = useState(false);
  const [disabledType, setDisabledType] = useState(false);

  useEffect(() => {
    const disabledCompany = JSON.parse(localStorage.getItem('publicProfDisabled'));
    if (disabledCompany) {
      setActiveDisabledCompany(true);
      setDisabledType(disabledCompany?.availabilityType);
      localStorage.removeItem('publicProfDisabled');
    }

    dispatch(setIsUiHidden(true));
    return () => {
      dispatch(setIsUiHidden(false));
    };
  }, []);

  const handleChangeLanguage = async languageCode => {
    i18n.changeLanguage(languageCode);
  };

  const menu = (
    <Menu>
      {languages.map(({ codeShort, codeLong }) => (
        <Menu.Item key={`lang-${codeShort}`} onClick={() => handleChangeLanguage(codeShort)}>
          {codeLong}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Layout>
      <DisabledProfModal
        modalOpen={activeDisabledCompany}
        setModalOpen={setActiveDisabledCompany}
        type={disabledType}
      />
      <Affix offsetTop={0} className="affix-style">
        <div
          style={{
            height: activeSearch ? 125 : 75,
            width: '100%',
            padding: '0 16px',
            backgroundColor: '#fafafa',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Row>
            <Col span={12} style={{ height: 75 }} className="align-items-end">
              <a href="/">
                <NewCreditLogo onClick={() => redirect('/')} />
              </a>
            </Col>
            <Col span={12}>
              <Space size="middle" style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                <Button
                  type="text"
                  icon={<UserOutlined />}
                  onClick={() => redirect('/')}
                  style={{ fontWeight: 'bold', color: '#555' }}
                >
                  {t('login.login')}
                </Button>
                {!publicProfView && (
                  <>
                    <div style={{ width: '1px', height: '16px', background: 'red' }}></div>
                    <Dropdown overlay={menu} trigger={['click']}>
                      <Space style={{ cursor: 'pointer', color: '#555', fontWeight: 'bold' }}>
                        <GlobalOutlined style={{ fontSize: '16px' }} />
                        {languages.find(lang => lang.codeShort === i18n.language)?.codeLong || 'ENG'}
                      </Space>
                    </Dropdown>
                  </>
                )}
              </Space>
            </Col>
            {activeSearch ? (
              <Col span={24}>
                <HeaderSearch />
              </Col>
            ) : null}
          </Row>
        </div>
      </Affix>
      <Content className="unauthenticated-content">{children}</Content>
    </Layout>
  );
};

export default UnauthenticatedWrapper;
